import React, { useState } from "react";
import "../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import download from "images/download.svg";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ActionModal from "./ActionModal";
import { useSelector } from "react-redux";
import moment from "moment";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
import MultiplePopup from "containers/gstr2a2bNewEnhancement/Utility/MultiplePopup";

const Table = () => {
  const [open, setOpen] = useState(false);
  const { docDateTableData } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  // const [open, setOpen] = useState(false);
  const [dialogName, setDialogName] = useState("");
  const [selectedRecord, setSelectedRecord] = useState([]);
  const handleMultiple = async (row, type) => {
    try {
      if (type === "Multiple Gstins") {
        setSelectedRecord(Array.isArray(row.GSTIN) ? row.GSTIN : [row.GSTIN]);
      } else {
        setSelectedRecord(
          Array.isArray(row.RET_PERIOD) ? row.RET_PERIOD : [row.RET_PERIOD]
        );
      }
      setDialogName(type);
      setOpen(true);
    } catch (error) {
      console.error("Error in handleMultiple:", error);
    }
  };
  const gstinColumnFormatter = (cell, row) => {
    // Split GSTIN string by comma and filter out empty values
    const gstins =
      typeof row.GSTIN === "string"
        ? row.GSTIN.split(",")
            .map((g) => g.trim())
            .filter(Boolean)
        : [row.GSTIN];

    const isMultiple = gstins.length > 1;
    const displayText = isMultiple ? "Multiple" : gstins[0] || "";

    return (
      <div
        style={{
          width: "100%",
          cursor: isMultiple ? "pointer" : "default",
          textDecoration: isMultiple ? "underline" : null,
          fontWeight: isMultiple ? "bold" : "normal",
          fontSize: "11px",
        }}
        onClick={
          isMultiple ? () => handleMultiple(row, "Multiple Gstins") : null
        }
      >
        {displayText}
      </div>
    );
  };
  const columns = [
    {
      dataField: "ID",
      text: "Reco ID",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "12%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ID"),
    },
    {
      dataField: "GSTIN",
      text: "GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "10%",
      },
      formatter: gstinColumnFormatter,
    },
    {
      dataField: "GSTR_2A_2B_FISCAL_YEAR",
      text: "Financial Year",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "12%",
      },
      formatter: (cell, row) => (
        <>
          {row.GSTR_2A_2B_FISCAL_YEAR
            ? row.GSTR_2A_2B_FISCAL_YEAR
            : row.PR_FISCAL_YEAR
            ? row.PR_FISCAL_YEAR
            : "--"}
        </>
      ),
    },
    {
      dataField: "RECO_BASE",
      text: "Reco Base",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "12%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RECO_BASE"),
    },
    {
      dataField: "DATE_RANGE",
      text: "Date Range Considered",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "14%",
      },
      formatter: (cell, row) =>{
        if(row?.RECO_BASE === 'TAX_PERIOD') {
          return displayNullFormatter(row, "DATE_RANGE");
        }
        else{
          const startDate = row?.START_RANGE_DATE || '';
          const endDate = row?.END_RANGE_DATE || '';
          if(startDate && endDate) {
            return `${startDate} - ${endDate}`;
          }
          return startDate || endDate || '--';
        }
      }
      // formatter: (cell, row) => displayNullFormatter(row, "DATE_RANGE"),
    },
    {
      dataField: "RECO_TYPE",
      text: "Reco Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "10%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RECO_TYPE"),
    },
    {
      dataField: "PIPELINE_STATUS",
      text: "Status",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "12%",
      },
      formatter: (cell, row) => {
        const status = row.PIPELINE_STATUS;
        if (status) {
          // Convert to lowercase first, then capitalize first letter
          return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
        }
        return "--";
      },
    },
    {
      dataField: "CREATED_DATETIME",
      text: "Generation Timestamp",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "12%",
      },
      formatter: (cell, row) => (
        <>
          {row.CREATED_DATETIME
            ? moment(row.CREATED_DATETIME).format("DD-MM-YYYY HH:mm:ss")
            : "--"}
        </>
      ),
    },

    // {
    //   dataField: "",
    //   text: "Action",
    //   style: (cell, row, rowIndex, colIndex) => ({
    //     ...commonStyle,
    //   }),
    //   headerStyle: {
    //     ...commonHeaderStyle,
    //     width: "6%",
    //   },
    //   formatter: (cell, row) => {
    //     return (
    //       <ErrorOutlineIcon
    //         style={{ height: "16px", cursor: "pointer" }}
    //         onClick={() => setOpen(true)}
    //       />
    //     );
    //   },
    // },
  ];
  return (
    <>
      {docDateTableData?.length > 0 ? (
        <div style={{ marginTop: "0.5em", width: "100%", overflowX: "scroll" }}>
          <div
            className="light-border-gstr2a2bnew-table"
            style={{
              marginTop: "0.6em",
              //   height: "25em",
              width: "130%",
              overflowY: "scroll",
            }}
          >
            <BootstrapTable
              keyField="ID"
              data={docDateTableData}
              columns={columns}
              rowStyle={rowStyle2}
            />
          </div>
          {/* <ActionModal open={open} setOpen={setOpen} /> */}
          <MultiplePopup
            open={open}
            onClose={() => setOpen(false)}
            dialogName={dialogName}
            selectedRecord={selectedRecord}
          />
        </div>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
